<template>
  <l-layout :layout="['xs12']">
    <v-card class="pa-3">
      <v-card-title>
        <span class="title">教工申请详情</span>
      </v-card-title>
      <v-form ref="form">
        <v-layout column>
          <v-layout>
            <v-flex xs6>
              <v-text-field label="教工姓名" prepend-icon="$vuetify.icons.person" v-model="form.name" disabled></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="教工号" prepend-icon="$vuetify.icons.person" v-model="form.loginId" disabled></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-text-field label="所在单位" prepend-icon="$vuetify.icons.group" v-model="form.orgName" disabled></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <v-text-field label="校内办公地点(请注明校区)" prepend-icon="$vuetify.icons.location" v-model="form.referPlace"
                            disabled></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="教工手机" prepend-icon="$vuetify.icons.phone" v-model="form.phone"
                            disabled></v-text-field>
            </v-flex>
          </v-layout>
         <!-- <v-layout>
            <v-flex xs6>
              <v-select prepend-icon="$vuetify.icons.parkingLot" label="进入校区" v-model="form.park" :items="parkList"
                        item-text="name" item-value="id" chips
                        :rules="[$rules.requiredS()]" disabled></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select prepend-icon="$vuetify.icons.parkingLot" label="进入卡口" v-model="form.controller" :items="form.controllerList"
                        item-text="name" item-value="id" chips multiple
                        :rules="[$rules.requiredS()]" disabled></v-select>
            </v-flex>
          </v-layout>-->
          <v-layout>
            <v-flex xs6>
              <v-text-field label="计划进校时间" prepend-icon="$vuetify.icons.datetime" v-model="form.stTime" disabled></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select label="进校事由类别" prepend-icon="$vuetify.icons.code" v-model="formData.reviewType" :items="select"
                        item-text="label" item-value="value" disabled></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <v-textarea label="进校事由详述" prepend-icon="$vuetify.icons.comment" v-model="form.comment" rows="1" auto-grow
                          disabled></v-textarea>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-form>
      <v-layout class="pl-3 ml-3">
        <p v-if="form.firstResult==='1'" style="color:green">二级单位审核状态：已通过</p>
        <v-layout v-else-if="form.firstResult==='2'">
          <p  style="color:red">二级单位审核状态：已拒绝。</p>
          <p  style="color:red">附言:{{formData.firstAuditComment}}</p>
        </v-layout>
        <p v-else >二级单位审核状态：待审核</p>
      </v-layout>
      <v-layout class="pl-3 ml-3">
        <p v-if="form.secondResult==='1'" style="color:green">业务部门审核状态：已通过</p>
        <v-layout v-else-if="form.secondResult==='2'">
          <p  style="color:red">业务部门审核状态：已拒绝。</p>
          <p  style="color:red">附言:{{formData.secondAuditComment}}</p>
        </v-layout>
        <p v-else-if="form.firstResult==='2'||form.firstResult==='0'">业务部门审核状态：N/A</p>
        <p v-else>业务部门审核状态：待审核</p>
      </v-layout>
      <v-layout justify-center v-if="status==='review'">
        <v-btn class="primary" @click="pass" :disabled="disabledFlag" :loading="loading">通过</v-btn>
        <v-btn class="error" @click="refuseConfirm" :disabled="disabledFlag">拒绝</v-btn>
      </v-layout>
    </v-card>
    <v-dialog v-model="confirmDialog.activated" width="500">
      <v-layout column>
        <v-card class="pa-3">
          <v-card-title>
            <span class="title">拒绝申请</span>
          </v-card-title>
          <v-form ref="refuseForm">
            <v-layout>
              <v-flex xs12>
                <v-textarea label="附言" prepend-icon="$vuetify.icons.comment" v-model="confirmDialog.hint" rows="1" auto-grow
                :rules="[$rules.requiredS()]"></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout justify-center>
            <v-btn class="primary" @click="refuse" :loading="loading" :disabled="disabledFlag">确认</v-btn>
            <v-btn class="error" @click="confirmDialog.activated=false" :disabled="disabledFlag">取消</v-btn>
          </v-layout>
        </v-card>
      </v-layout>
    </v-dialog>
  </l-layout>
</template>

<script>
    export default {
        name: "reviewDetails",
        props:{
          formData:{
            type:Object,
            default:function () {
              return {}
            }
          }
        },
      data(){
        return {
          select:[
            {value:'1',label:'科学研究类'},
            {value:'2',label:'本科生教学类'},
            {value:'3',label:'研究生教学类'},
            {value:'4',label:'行政办公类'}
          ],
          form:{
            park:'',
            parkName:'',
            controller:[],
            controllerName:'',
            controllerList:[],
            comment:"",
            referPlace:"",
            orgName:'',
            orgId:'',
            stTime:'',
            edTime:'',
            name:'',
            loginId:'',
            phone:'',
            firstResult:'',
            secondResult:'',
          },
          loading:false,
          disabledFlag:false,
          confirmDialog: {
            activated:false,
            hint:''
          },
          status:''
        }
      },
      computed:{
        parkList(){
          let arr = this.$store.state.parkingLot.parkingLotList
          //console.log(arr)
          return arr
        },
        controllerList(){
          let arr = this.$store.state.parkingLot.unDirControllerList
          return arr
        },
      },
      created(){
        if(this.$route.query.status!==undefined){
          this.status = this.$route.query.status
        }
          this.init()
      },
      methods:{
          init(){
            this.form.stTime = this.formData.stTime
            this.form.edTime = this.formData.edTime
            this.form.name = this.formData.name
            this.form.comment = this.formData.reqComment
            this.form.referPlace = this.formData.reqReferPlace
            this.form.loginId = this.formData.loginId
            this.form.firstResult = this.formData.firstAuditStatus+''
            this.form.secondResult = this.formData.secondAuditStatus+''
            this.getUserInfo()
            let type = this.$route.query.type
            if(type!==undefined){
              this.type = type+''
              if(type+'' === '1'){
                if(this.formData.firstAuditStatus+''!=='0'){
                  this.status = 'readonly'
                }
              }
              if(type+'' === '2'){
                if(this.formData.secondAuditStatus+''!=='0'){
                  this.status = 'readonly'
                }
              }
            }
            if(this.status === ''){
              this.status = 'review'
            }
          },
        initController(str){
            let arr = str.split(',')
            this.form.controller = arr
            for(let i=0;i<this.controllerList.length;i++){
              if(this.controllerList[i].id === arr[0]){
                this.form.park = this.controllerList[i].park[0].id
                break
              }
            }
        },
        async pass(){
          let params = {
            "id":this.formData.id,
            "status":"1",
            "comment":""
          }
          try {
            this.loading = true
            let type = this.$route.query.type
            let res = null
            if(type==='1'){
              res = await this.$store.dispatch('school/firstReview',params)
            }else{
              res = await this.$store.dispatch('school/secondReview',params)
            }
            if(res.data.status === 1){
              this.$L.alert('success',{message:'审核成功'})
              this.disabledFlag = true
            }else{
              this.$L.alert('error',{message:'审核失败,原因:'+res.data.msg})
            }
          }catch (e) {

          }finally {
            this.loading = false
          }
        },
        refuseConfirm(){
          this.confirmDialog.activated = true
        },
        async getUserInfo(){
          let p = await this.$store.dispatch('login/getThemSelfInfo',this.form.loginId)
          console.log(p)
          this.form.phone = p.phone
          this.form.orgName = p.orgName
        },
        async refuse(){
          if(!this.$refs.refuseForm.validate()){
            this.$L.alert('error',{message:'表单数据不合法'})
            return
          }
          let params = {
            "id":this.formData.id,
            "status":"2",
            "comment":this.confirmDialog.hint
          }
          try {
            this.loading = true
            let type = this.$route.query.type
            let res = null
            if(type==='1'){
              res = await this.$store.dispatch('school/firstReview',params)
            }else{
              res = await this.$store.dispatch('school/secondReview',params)
            }
            if(res.data.status === 1){
              this.$L.alert('success',{message:'审核成功'})
              this.disabledFlag = true
              this.confirmDialog.activated = false
            }else{
              this.$L.alert('error',{message:'审核失败,原因:'+res.data.msg})
            }
          }catch (e) {

          }finally {
            this.loading = false
          }
        }
      },
      watch:{
        'form.park'(){
          this.form.controllerList = []
          for(let i=0;i<this.controllerList.length;i++){
            if(this.controllerList[i].park[0].id === this.form.park){
              this.form.controllerList.push(this.controllerList[i])
            }
          }
        },
      },
    }
</script>

<style scoped>

</style>
